import RichTextHeadline from 'components/shared/RichTextHeadline/RichTextHeadline';
import RichTextCopy from 'components/shared/RichTextCopy/RichTextCopy';
import CTA, { isValidCta } from 'components/shared/CTA/CTA';
import { liveUpdateAttrs } from 'libs/contentful/utils';
import { cn, getColorway, getSectionProps } from 'utils/styles';
import { Colorways, ColorTheme } from 'types/constants';
import { ExplainerProps } from './types';
import ExplainerSlider from './ExplainerSlider';

const Explainer = ({ sys, sectionName, headline, copy, cta, explainerSlides, colorTheme, margins }: ExplainerProps) => {
  const slides = explainerSlides?.items ?? [];

  /**
   * Color theme drives two inverse palettes:
   * Primary Light: white section + dark-green card.
   * Primary Dark: dark-green section + white card.
   */
  const isDark = colorTheme === ColorTheme.PrimaryDark;
  const sectionColorway = isDark ? Colorways.Inverse : Colorways.Primary;
  const cardColorway = isDark ? Colorways.Primary : Colorways.Inverse;

  return (
    <section {...getSectionProps(sectionColorway, margins, sectionName)} data-testid="explainer">
      <div className="content-wrapper">
        <div
          className={cn(
            'flex flex-col-reverse overflow-hidden rounded-2xl md:flex-row md:rounded-3xl',
            getColorway(cardColorway),
          )}>
          <div className="flex w-full flex-col justify-center gap-8 px-6 pt-12 pb-6 md:w-1/2 md:py-20 md:pl-28 md:pr-14">
            <div className="flex flex-col gap-6">
              <div
                className="font-display text-heading-md md:text-heading-xl"
                {...liveUpdateAttrs(sys?.id, 'headline')}>
                <RichTextHeadline headline={headline} level="h2" />
              </div>
              {copy && (
                <div className="font-sans text-body-saans" {...liveUpdateAttrs(sys?.id, 'copy')}>
                  <RichTextCopy copy={copy} ySpacing="none" />
                </div>
              )}
            </div>
            {isValidCta(cta) && (
              <div className="w-full md:w-auto" {...liveUpdateAttrs(sys?.id, 'cta')}>
                <CTA cta={cta} variant="outline" className="w-full border-verde hover:border-current md:w-auto" />
              </div>
            )}
          </div>
          {slides.length > 0 && (
            <div className="w-full md:w-1/2">
              <ExplainerSlider slides={slides} cardIsDark={!isDark} />
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Explainer;
